import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import CarrierCatalog from '@app/pages/customer/CarrierCatalog/CarrierCatalog.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const CarrierCatalogPage = () => {
  const { tr } = useTranslationLgs();
  return (
    <ResponsiveLayout title={tr('index.carrierCatalogTitle', 'Katalog dopravců')} oneOfPermission={[PermissionTypesEnum.PERMISSION_CARRIER_CATALOGUE]}>
      <CarrierCatalog />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CarrierCatalogPage);
